<template>
    <div class="ui-select" @click="is_open = !is_open">
        <label v-if="selected_index === -1">{{default_text}} ↓</label>
        <label v-else>{{data[selected_index].text}} ↓</label>
        
        <ul v-if="is_open">
            <li v-for="(item, index) in data" :key="index" @click="selected(index)">
                {{item.text}}
            </li>
        </ul>
    </div>
</template>

<script>

export default {
    name: 'ui-select',

    props: {
        data: {
            type: Array,
            default: false,
        },
        default_text: {
            type: String,
            default: 'Choose an option',
        },
        default_value: {
            type: Number,
            default: -1,
        },
    },

    data() {
        return {
            is_open: false,
            selected_index: -1,
        }
    },

    methods: {
        selected(index) {
            this.selected_index = index;
            this.$emit('selected', this.data[this.selected_index]);
        },

        handleClick(e) {
            if (!this.is_open) return;
            // console.log(e.target)
            let root_parent = document.body;
            let is_select_el = false;


            if (e.target.classList.contains('ui-select')) {
                is_select_el = true;
            } else {
                let p = e.target.parentNode;

            
                while (p !== root_parent) {
                    var o = p;
                    p = o.parentNode;
                    if (o.classList.contains('ui-select')) is_select_el = true;
                }
            }

            if (!is_select_el) this.is_open = false;

            // console.log(1)
        },
    },

    mounted() {
        if (this.default_value !== -1) this.selected_index = this.default_value;

        // window.addEventListener('click', (e) => {
        //     self.is_open = false;
        // });
    },

    created () {
        window.addEventListener('click', this.handleClick);
    },

    destroyed () {
        window.removeEventListener('click', this.handleClick);
    },
}

</script>


<style lang="scss">
    .ui-select {
        font-size: var(--small-size);
        cursor: pointer;
        display: inline-block;
        position: relative;
        box-sizing: border-box;
        z-index: 9;

        label {
            display: block;
            cursor: pointer;
        }

        ul {
            border: var(--line-2) solid;
            position: absolute;
            top: 100%;
            background: white;
            box-sizing: border-box;
            min-width: 10rem;

            li {
                padding: .5rem 1rem;
                list-style: none;

                &:hover {
                    background: var(--light-gray);
                }
            }
        }
    }

    @media only screen and (max-width: 767px) {
        .ui-select {
            min-width: 50rem;
            padding-right: 6rem;

            svg {
                right: .75rem;
                height: 4rem;
                width: 4rem;
                margin: -2rem 0 0;
            }

            label {
                padding: .5rem 1rem;
            }

            ul {
                li {
                    padding: 1rem;
                }
            }
        }

    }
</style>